export enum TebligatTuru {
    normal = 'normal',
    hizli = 'hizli'
}

export enum TebligatTuruLabel {
    normal = 'Normal Tebligat',
    hizli = 'Hızlı Tebligat'
}